import { MAIN_FAQ } from '@smarty-nx/code-utils'

interface HelpTopic {
  title: string
  url: string
  data_item_name: string
}

interface HelpTopicsContent {
  title: string
  topics: HelpTopic[]
}

export const helpTopicsContent: HelpTopicsContent = {
  title: 'Get help on a specific topic',
  topics: [
    {
      title: 'Getting started with SMARTY',
      url: `${MAIN_FAQ}/en/collections/607870-getting-started-with-smarty`,
      data_item_name: 'getting-started',
    },
    {
      title: 'Data, calls, and texts',
      url: `${MAIN_FAQ}/en/collections/607861-data-calls-and-texts`,
      data_item_name: 'data-calls-and-texts',
    },
    {
      title: 'Deliveries',
      url: `${MAIN_FAQ}/en/articles/1155166-sim-delivery`,
      data_item_name: 'deliveries',
    },
    {
      title: 'Account and billing',
      url: `${MAIN_FAQ}/en/collections/607879-account-and-billing`,
      data_item_name: 'account-and-billing',
    },
    {
      title: 'Group plans',
      url: `${MAIN_FAQ}/en/collections/1974243-group-plans`,
      data_item_name: 'group-plans',
    },
    {
      title: 'SIM and device help',
      url: `${MAIN_FAQ}/en/collections/607915-sim-and-device-help`,
      data_item_name: 'sim-and-device-help',
    },
    {
      title: 'Going or calling abroad',
      url: `${MAIN_FAQ}/en/collections/607945-going-or-calling-abroad`,
      data_item_name: 'going-or-calling-abroad',
    },
    {
      title: 'Privacy and security',
      url: `${MAIN_FAQ}/en/collections/1358648-privacy-and-security`,
      data_item_name: 'privacy-and-security',
    },
    {
      title: 'Network and service',
      url: `${MAIN_FAQ}/en/collections/2644490-network-and-service`,
      data_item_name: 'network-and-service',
    },
  ],
}
